import { render, staticRenderFns } from "./maintenanceDeviceWarnConfigModal.vue?vue&type=template&id=638ab507"
import script from "./maintenanceDeviceWarnConfigModal.vue?vue&type=script&lang=js"
export * from "./maintenanceDeviceWarnConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports